import { FormApi } from 'informed';

import { AllFormFieldModelsType } from '../../types/FieldModelTypes';
import {
  isCurrentStepValid,
  runAfterFormValidation,
  runValidationAndProceed
} from '../../utils/MultiStepFormValidationUtils';

interface UseStepValidationParams {
  formApi: FormApi;
  stepFields: AllFormFieldModelsType[];
  designSystemType?: string;
  isInlineOtpVerified: () => boolean;
  isInlineOtpVerificationPending: () => boolean;
  clearInlineOtpVerificationError: () => void;
  showInlineOtpVerificationError: () => void;
  onValidSubmission: () => void;
}

export const useStepValidation = ({
  formApi,
  stepFields,
  designSystemType,
  isInlineOtpVerified,
  isInlineOtpVerificationPending,
  clearInlineOtpVerificationError,
  showInlineOtpVerificationError,
  onValidSubmission
}: UseStepValidationParams) => {
  const checkIsCurrentStepValid = (): boolean =>
    isCurrentStepValid(formApi, stepFields);

  const runShadcnValidationAndProceed = (): void => {
    if (isInlineOtpVerified()) {
      clearInlineOtpVerificationError();
    }

    formApi.submitForm();

    if (isInlineOtpVerificationPending()) {
      showInlineOtpVerificationError();
      return;
    }

    runAfterFormValidation(
      formApi,
      () => {
        if (!checkIsCurrentStepValid()) {
          return;
        }

        onValidSubmission();
      },
      () => undefined
    );
  };

  const runOmegaValidationAndProceed = (): void => {
    runValidationAndProceed(formApi, checkIsCurrentStepValid, onValidSubmission);
  };

  const validateAndProceed = (): void => {
    const shouldUseShadcnDesignSystem =
      designSystemType === 'SHADCN_DESIGN_SYSTEM';

    if (shouldUseShadcnDesignSystem) {
      runShadcnValidationAndProceed();
    } else {
      runOmegaValidationAndProceed();
    }
  };

  return {
    validateAndProceed,
    isCurrentStepValid: checkIsCurrentStepValid
  };
};
